import Header from '../components/header.js';
//import WhiteThinLine from '../components/line.js';
import CheckIsMobile from '../components/mobile.js';

export default function Application()
{
    let isMobile = CheckIsMobile();

    const H1Style = {
        textAlign: "center",
        display:"flex", 
        paddingTop: isMobile ? "1.5rem" : "2.5rem", 
        paddingBottom: isMobile ? "1.5rem" : "2.5rem", 
        justifyContent:"center", 
        alignContent:"center", 
        padding: "20px", 
        color:"cyan"
    }

    let ThickCyanLineStyle = {
        borderWidth: "1.5px", 
        borderColor: "cyan", 
        width: isMobile ? "45%" : "22%",    
        marginLeft: "auto", 
        marginRight: "auto"
    }

    let ParagraphStyle = {
        lineHeight: isMobile ? 2.0 : 2.5, 
        color: "white", 
        fontSize: isMobile ? "1.3rem" : "1.5rem", 
        paddingLeft: isMobile ? 50 : 90, 
        font: "large", 
        alignItems: "center", 
        justifyContent: "center"
    }

    return (
        <div>
            <Header />

            <section style={ H1Style }>
                <h1 style={{ fontSize: isMobile ? "2.0rem" : "2.5rem" }}>Applications</h1>
            </section>
            <hr style={ ThickCyanLineStyle } /> <br />
            
            <section style={ ParagraphStyle }>
                <p>Identification</p>
                <p>Classification</p> 
                <p>Measurement</p>
                <p>Process Control</p> 
            </section> 

            <br/> <hr style={{ borderWidth: "1.5px", borderColor: "white", width: "90%",          
                               marginLeft: "auto", marginRight: "auto", marginTop: "1rem" }} />

            <br /> <br /> <br /> <br /> <br /> <br /><br /> <br /> <br /> <br />
        </div>
    );
}
